import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { onCompanySettingLoad } from '../../../store/Settings/actions';
import { OrderTypeBadge } from '../../../components/OrderTypeBadge';
import { OrderInfoBadge } from '../../../components/OrderInfoBadge';
import OrderStatusBadge from '../../../components/OrderStatusBadge';

export const OrdersTable = ({ orders }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { currency } = useSelector(({ settings }) => ({ currency: settings.company_preferences.currency }));

    const dateFormat = (orderDate) => {
        const date = new Date(orderDate);
        return new Intl.DateTimeFormat('en-AU', {
            timeZone: 'Australia/Sydney',
        }).format(date);
    };

    const timeFormat = (orderDate) => {
        const date = new Date(orderDate);
        return new Intl.DateTimeFormat('default', {
            hour: 'numeric',
            minute: 'numeric',
        }).format(date);
    };

    useEffect(() => {
        dispatch(onCompanySettingLoad());
    }, []);

    return (
        <table className="min-w-full border-b border-gray-100">
            <thead className="">
                <tr>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        Order ID
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Date')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Order type')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Order info')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Order status')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Client')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Restaurant')}
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-medium text-gray-500 tracking-wider">
                        {t('Total')}
                    </th>
                </tr>
            </thead>
            <tbody className="bg-white">
                {orders.map((order) => (
                    <tr key={order.id} className="odd:bg-gray-50">
                        <td className="px-6 p-5 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-sm font-medium">
                                    <a href={`/chain/orders/${order.id}`} target="_blank" className="text-indigo-600 hover:text-indigo-900">
                                        {order.id}
                                    </a>
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-2 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-[13px] font-medium flex flex-col gap-1">
                                    <div>{dateFormat(order.created_at)}</div>
                                    <div className="text-gray-500 font-normal lowercase">{timeFormat(order.created_at)}</div>
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <OrderTypeBadge type={order.type} />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm">
                                <OrderInfoBadge type={order.type} time={timeFormat(order.created_at)} tableNumber={order.table_code}/>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm">
                                <OrderStatusBadge status={order.status} />
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm">
                                <a href={`/chain/clients/${order.client.id}`} target="_blank" className="text-indigo-600 hover:text-indigo-900">
                                    {order.client.name}
                                </a>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm">
                                <Link to={`/chain/stores/${order.restaurant.id}`} className="text-indigo-600 hover:text-indigo-900">
                                    {order.restaurant.name}
                                </Link>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm">
                                {currency.title} &nbsp;{order.total.toFixed(2)}
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
